import { useState } from 'react'
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog'
import type { EstadoTarea } from '@/types/database'

interface Pendiente {
  accion: () => void
  cantidad: number
}

/**
 * Pide confirmación antes de completar tareas. `confirmar` corre la acción en el momento si el
 * estado nuevo no es `completada`, y si lo es la guarda hasta que el usuario confirme. `dialogo`
 * se renderiza una vez en el componente que llama.
 */
export function useConfirmarCompletar() {
  const [pendiente, setPendiente] = useState<Pendiente | null>(null)

  const confirmar = (estado: EstadoTarea, accion: () => void, cantidad = 1) => {
    if (estado !== 'completada') {
      accion()
      return
    }
    setPendiente({ accion, cantidad })
  }

  const dialogo = (
    <AlertDialog open={pendiente !== null} onOpenChange={(abierto) => !abierto && setPendiente(null)}>
      <AlertDialogContent onClick={(e) => e.stopPropagation()}>
        <AlertDialogHeader>
          <AlertDialogTitle>
            {pendiente && pendiente.cantidad > 1
              ? `¿Querés cerrar ${pendiente.cantidad} tareas como completadas?`
              : '¿Querés cerrar la tarea como completada?'}
          </AlertDialogTitle>
          <AlertDialogDescription>
            Se guarda la fecha de hoy como fecha de completada. Podés reabrirla después.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancelar</AlertDialogCancel>
          <AlertDialogAction
            onClick={() => {
              pendiente?.accion()
              setPendiente(null)
            }}
          >
            Completar
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )

  return { confirmar, dialogo }
}
